import type { DialogueContext, DialogueInput, DialogueProvider, DialogueReply, DialogueSession } from "./provider.js";

/** Plays the dialogue trees stored in the manifest. Deterministic, offline, no free text. */
export class ScriptedDialogueProvider implements DialogueProvider {
  readonly supportsFreeText = false;

  async open(context: DialogueContext): Promise<DialogueReply> {
    return this.node(context, context.character.script.start);
  }

  async respond(session: DialogueSession, input: DialogueInput, context: DialogueContext): Promise<DialogueReply> {
    const script = context.character.script;
    const node = script.nodes[session.state as string];
    if (input.type !== "choice" || !node) return { session, text: "", choices: [], actions: [], ended: true };
    const index = Number(/^o(\d+)$/.exec(input.choiceId)?.[1]);
    const option = node.options[index];
    if (!option) return { session, text: "", choices: [], actions: [], ended: true };
    const actions = option.action ? [option.action] : [];
    if (!option.next || !script.nodes[option.next]) return { session, text: "", choices: [], actions, ended: true };
    const next = this.node(context, option.next);
    return { ...(await next), actions };
  }

  private node(context: DialogueContext, nodeId: string): DialogueReply {
    const node = context.character.script.nodes[nodeId];
    const session: DialogueSession = { characterId: context.character.id, state: nodeId };
    if (!node) return { session, text: "", choices: [], actions: [], ended: true };
    return {
      session,
      text: node.say,
      choices: node.options.map((o, i) => ({ id: `o${i}`, text: o.text })),
      actions: [],
      ended: node.options.length === 0
    };
  }
}
